export class notificationAlertModel {
setValue(res){
if(res){
}
}
}